$(document).ready(function () {

    const ajaxPathGetOrder = '/action/goods-receipt/get-order';
    const ajaxPathAddToStock = '/action/goods-receipt/add-to-stock';
    const ajaxPathDeleteProductOrder = '/action/goods-receipt/delete-product-order';
    const ajaxPathDeleteBackOrder = '/action/goods-receipt/delete-back-order';
    const ajaxPathGetSearchResult = '/action/goods-receipt/get-search-result';
    const ajaxPathRefreshOrderListItems = '/action/goods-receipt/refresh-order-list-items';
    const ajaxPathGetSendMailModal = '/action/product-order/get-send_mail_modal';
    const ajaxPathSendBackOrderMail = '/action/product-order/send-product-order-mail';
    const ajaxPathUpdateProductsTable = '/action/goods-receipt/update-products-table';
    let inputHasChanged = false;
    let ajaxLocked = false;
    let modalParentElementInDOM = $('div#content');
    let modalTitle = '';
    let modalMessage = '';
    let modalButtonText = 'Lukk';
    let modalAlertType = '';

    let noFilterMatch = $('div#goods_receipt_wrapper td#no_filter_match').val();
    if (noFilterMatch === 'Ingen varer matchet med filteret som er satt' || noFilterMatch === 'Fant ingen varer i denne bestillingen') {
        $('div#goods_receipt_wrapper div#comment_input_wrapper').remove();
        $('div#goods_receipt_wrapper div#save_button_wrapper').remove();
    }


    //Check if any amount input has been changed
    $(document).on('change', 'table#product_order_table input.form-control', function () {
        inputHasChanged = true;
    });

    //Print products from product order in table
    $(document).on('click', 'div#product_order_list_wrapper a.product_order_list_item', function () {
        removeAlertMessage();
        let productOrderId = $(this).parents('.list-item-product-order').first().attr("product_order_id");
        getOrder(productOrderId);
    });

    //Save and add to stock
    $(document).on('click', 'div#goods_receipt_wrapper button#save_add_to_stock', function () {
        removeAlertMessage();
        $(this).html('<img src="/includes/article/images/loading.gif?v=1.000" style="width:20px; height: 20px;"/>  Lagre varemottak')
        let obj = {};
        let productOrderId = $('div#goods_receipt_wrapper input#product_order_id');
        let backOrderId = $('div#goods_receipt_wrapper input#back_order_id');
        let commentInput = $('div#goods_receipt_wrapper input#goods_receipt_comment_input');
        let amountInputs = $("div#goods_receipt_wrapper div#products_table_wrapper").find('input').serialize();

        if (productOrderId.length) {
            obj['product_order_id'] = productOrderId.val();
        }
        if (backOrderId.length) {
            obj['back_order_id'] = backOrderId.val();
        }
        if ($.trim(commentInput.val()).length) {
            obj['comment_input'] = commentInput.val();
        }
        if (amountInputs.length) {
            obj['amount_inputs'] = amountInputs;
        }
        saveAddToStock(obj);
    });

    // Forgot to save?
    $(window).bind('beforeunload', function() {
        if ($("div#goods_receipt_wrapper div#left_side_form").length > 0 && inputHasChanged === true && $('div#alert_message').length === 0) {
            return 'Du har ikke lagret endringer i varemottaksskjemaet. Er du sikker på at du vil forlate siden?';
        }
    });

    //Print products from back order in table
    $(document).on('click', 'div#back_order_list_wrapper a.back_order_list_item', function () {
        removeAlertMessage();
        let backOrderId = $(this).parents('.list-item-product-order').first().attr("back_order_id");
        let isBackOrder = 1;
        getOrder(backOrderId, isBackOrder);
    });

    //Delete (set status to 0) on product order
    $(document).on('click', 'div#product_order_list_wrapper a.delete-order', function () {
        removeAlertMessage();
        if (confirm("Er du sikker på at du vil slette denne varebestillingen?")) {
            let productOrderId = $(this).parents('.list-item-product-order').first().attr("product_order_id");
            deleteProductOrder(productOrderId);
        }
    });

    //Delete (set status to 0) on back order
    $(document).on('click', 'div#back_order_list_wrapper a.delete-order', function () {
        removeAlertMessage()
        if (confirm("Er du sikker på at du vil slette denne restordren?")) {
            let backOrderId = $(this).parents('.list-item-product-order').first().attr("back_order_id");
            deleteBackOrder(backOrderId);
        }
    });

    //Get search result for products
    $(document).on('click', 'div#left_side_form button#products_search_btn', function () {
        if ($('input#input#products_search_input').val() !== '') {
            if ($('div#left_side_form div#product_order_info_wrapper').length) {
                getSearchResult();
            } else {
                let searchInput = $('input#products_search_input').val();
                let url = updateURLParameter(window.location.href, "q", searchInput);
                url = updateURLParameter(url, "page", 1);
                window.history.replaceState('', '', url);
                window.location.href = url;
            }
        }
    });

    //Open modal for sending mail
    $(document).on('click', 'div#back_order_item_list_wrapper a.open_send_mail_modal', function () {
        $('div#left_side_form div#alert_message').remove();
        let backOrderId = $(this).parents('.list-item-product-order').first().attr("back_order_id");
        openSendMailModal(backOrderId);
    });

    //Send order by mail
    $(document).on('click', 'div#goods_receipt_wrapper button#send_order_mail', function () {
        sendOrderByMail();
    });

    //Get search result for products when ENTER is pressed or input is removed
    $('div#left_side_form input#products_search_input').keyup(function (e) {
        let key = e.which;
        let searchInput = $('input#products_search_input').val();

        // Refresh list if enter was pressed or the search field is empty
        if (key === 13 || searchInput === '') {
            if ($('div#left_side_form div#product_order_info_wrapper').length) {
                if (searchInput === '') {
                    $("tr.selectedFromSearch").removeClass("selectedFromSearch");
                } else {
                    getSearchResult();
                }
            } else {
                let url = updateURLParameter(window.location.href, "q", searchInput);
                url = updateURLParameter(url, "page", 1);
                window.history.replaceState('', '', url);
                window.location.href = url;
            }
        }
    });

    //Get filter result after changing product group filter
    $(document).on('change', 'div#left_side_form select[name="product_group_filter"]', function () {
        removeAlertMessage();
        let url = updateURLParameter(window.location.href, "product_group", $(this).val());
        url = updateURLParameter(url, "page", 1);
        window.history.replaceState('', '', url);
        window.location.href = url;
    });

    //Get filter result after changing product group filter
    $(document).on('change', 'div#left_side_form select[name="supplier_filter"]', function () {
        removeAlertMessage();
        let url = updateURLParameter(window.location.href, "supplier_id", $(this).val());
        url = updateURLParameter(url, "page", 1);
        window.history.replaceState('', '', url);
        window.location.href = url;
    });

    function saveAddToStock(obj) {
        if (ajaxLocked) {
            return
        }
        if (obj instanceof Object) {
            let formData = new FormData();

            if ('product_order_id' in obj) {
                formData.append('product_order_id', obj.product_order_id);
            }
            if ('back_order_id' in obj) {
                formData.append('back_order_id', obj.back_order_id);
            }
            if ('comment_input' in obj) {
                formData.append('comment_input', obj.comment_input);
            }
            if ('amount_inputs' in obj) {
                formData.append('amount_inputs', obj.amount_inputs);
            }

            ajaxLocked = true;
            $.ajax({
                type: 'POST',
                url: ajaxPathAddToStock,
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json'
            }).success(function (data) {
                window.scrollTo(0, 0);
                let prependToElement = $('div#goods_receipt_wrapper div#left_side_form');
                let messageToDisplay = '';

                let href = "<a title=\"Lag nytt varemottak\" href='" + window.location.pathname + "'>her</a>";

                if (data.back_order_created === true) {
                    messageToDisplay = 'Bestillingen ble lagerført, og en ny restordre ble opprettet.';
                    messageToDisplay += '<br/><br/>Trykk ' + href + ' for å opprette nytt varemottak, eller trykk på en bestilling i menyen til høyre for å lagerføre en ny varebestilling.';
                } else {
                    messageToDisplay = 'Bestillingen ble lagerført, og varene er lagt til i lagerbeholdningen.';
                }
                displayAlertMessage('Varemottak registrert!', messageToDisplay, 'success', prependToElement);

                //remove table and info about the order if a order was saved
                if ('product_order_id' in obj || 'back_order_id' in obj) {
                    $('div#goods_receipt_wrapper div#product_order_info_wrapper').empty();
                    $('div#goods_receipt_wrapper div#products_search_wrapper').empty();
                    $('div#goods_receipt_wrapper div#products_table_wrapper').empty();
                    $('div#goods_receipt_wrapper div#comment_input_wrapper').empty();
                    $('div#goods_receipt_wrapper div#save_button_wrapper').empty();
                } else {
                    updateProductsTable(obj);

                    //iterate input fields and set value = ""
                    $('div#goods_receipt_wrapper table#product_order_table').find('input').each(function () {
                        $(this).val('');
                    });
                }

                refreshOrderListItems();

                return false;
            }).error(function (data) {
                modalTitle = 'Det oppstod en feil!';
                modalMessage = $.parseJSON(data.responseText).errors;
                modalAlertType = 'error';

                displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
            }).always(function () {
                $('div#goods_receipt_wrapper button#save_add_to_stock').html('Lagre varemottak');
                ajaxLocked = false;
            });
        }
    }

    function deleteProductOrder(productOrderId) {
        $.ajax({
            type: 'PUT',
            url: ajaxPathDeleteProductOrder,
            data: {
                product_order_id: productOrderId,
            },
            dataType: 'json'
        }).success(function (data) {
            refreshOrderListItems();

        }).error(function (data) {
            modalTitle = 'Det oppstod en feil!';
            modalMessage = $.parseJSON(data.responseText).errors;
            modalAlertType = 'error';

            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
        });
    }

    function deleteBackOrder(backOrderId) {
        $.ajax({
            type: 'PUT',
            url: ajaxPathDeleteBackOrder,
            data: {
                back_order_id: backOrderId,
            },
            dataType: 'json'
        }).success(function (data) {
            refreshOrderListItems();

        }).error(function (data) {
            modalTitle = 'Det oppstod en feil!';
            modalMessage = $.parseJSON(data.responseText).errors;
            modalAlertType = 'error';

            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
        });
    }

    function getSearchResult() {
        let searchString = $('div#goods_receipt_wrapper input#products_search_input').val();

        let productOrderId = 0;
        if ($('div#product_order_info_wrapper input#product_order_id').length) {
            productOrderId = $('div#product_order_info_wrapper input#product_order_id').val();
        }

        let backOrderId = 0;
        if ($('div#product_order_info_wrapper input#back_order_id').length) {
            backOrderId = $('div#product_order_info_wrapper input#back_order_id').val();
        }

        $.ajax({
            type: 'GET',
            url: ajaxPathGetSearchResult,
            data: {
                search_string: searchString,
                product_order_id: productOrderId,
                back_order_id: backOrderId,
            },
            dataType: 'json'
        }).success(function (data) {
            //remove selected class on previously selected row
            $("tr.selectedFromSearch").removeClass("selectedFromSearch");
            let trId = $.trim(data.product_id);

            //If a match is found
            if (trId !== '') {
                let container = $('div#goods_receipt_wrapper div#products_table_wrapper');
                let scrollTo = $("table#product_order_table tr#" + trId);

                //set this row background with "selected" color
                scrollTo.addClass('selectedFromSearch');

                container.scrollTop(
                    scrollTo.offset().top - container.offset().top + container.scrollTop()
                );

            } //End if

        }).error(function (data) {
            modalTitle = 'Det oppstod en feil!';
            modalMessage = $.parseJSON(data.responseText).errors;
            modalAlertType = 'error';
            if (modalMessage === 'Ingen varer matchet med søket.') {
                $('button#products_search_btn').notify(modalMessage, {position: "right", className: "error"});
            } else {
                displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
            }
        });
    }

    function getOrder(OrderId, isBackOrder = 0) {
        $.ajax({
            type: 'GET',
            url: ajaxPathGetOrder,
            data: {
                order_id: OrderId,
                is_back_order: isBackOrder,
            },
            dataType: 'json'
        }).success(function (data) {
            $('div#goods_receipt_wrapper div#products_filter_wrapper').remove();
            $('div#goods_receipt_wrapper div#pagination_wrapper').remove();
            $('div#goods_receipt_wrapper div#products_table_wrapper').replaceWith(data.html_table);
            $('div#left_side_form div#product_order_info_wrapper').remove();
            $('div#goods_receipt_wrapper div#left_side_form').prepend(data.html_order_info);

            $('div#goods_receipt_wrapper div#products_search_wrapper').replaceWith(data.html_search_field);
            $('div#goods_receipt_wrapper div#comment_input_wrapper').replaceWith(data.html_comment_field);
            $('div#goods_receipt_wrapper div#save_button_wrapper').replaceWith(data.html_save_button);

        }).error(function (data) {
            modalTitle = 'Det oppstod en feil!';
            modalMessage = $.parseJSON(data.responseText).errors;
            modalAlertType = 'error';

            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
        });
    }

    //Send order by mail, open modal
    function openSendMailModal(backOrderId) {
        $('div#send_mail_modal_wrapper').remove();
        $('.modal').modal('hide');
        let isBackOrder = 1;

        $.ajax({
            type: 'GET',
            url: ajaxPathGetSendMailModal,
            data: {
                order_id: backOrderId,
                is_back_order: isBackOrder,
            },
            dataType: 'json'
        }).success(function (data) {
            $('div#goods_receipt_wrapper').append('<div id="send_mail_modal_wrapper"></div>');
            $('div#send_mail_modal_wrapper').append(data.html);
            $("div#send_email_modal").modal('toggle');

        }).error(function (data) {
            modalTitle = 'Det oppstod en feil!';
            modalMessage = $.parseJSON(data.responseText).errors;
            modalAlertType = 'error';

            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
        });
    }

    function sendOrderByMail() {
        if (ajaxLocked) {
            return;
        }
        let supplierEmailAddress = $('div#send_email_modal input#supplier_email_modal').val();
        let copyEmailAddress = $('div#send_email_modal input#copy_email_modal').val();
        let productOrderId = $('div#send_email_modal input#order_id').val();
        let isBackOrder = 1;

        ajaxLocked = true;
        $.ajax({
            type: 'POST',
            url: ajaxPathSendBackOrderMail,
            data: {
                supplier_email_address: supplierEmailAddress,
                copy_email_address: copyEmailAddress,
                order_id: productOrderId,
                is_back_order: isBackOrder
            },
            dataType: 'json'
        }).success(function (data) {
            $('div#send_mail_modal_wrapper').remove();
            let element = $('div#goods_receipt_wrapper div#left_side_form');
            if (copyEmailAddress === '') {
                displayAlertMessage('E-post sendt!', 'Bestilling sendt til: ' + supplierEmailAddress + '.', 'success', element);
            } else {
                displayAlertMessage('E-post sendt!', 'Bestilling sendt til: ' + supplierEmailAddress + '.<br/> Kopi sendt til: ' + copyEmailAddress + '.', 'success', element);
            }

        }).error(function (data) {
            let element = $('div#send_email_modal_content');
            let errorMessage = $.parseJSON(data.responseText).errors;

            displayAlertMessage('Det oppstod en feil!', errorMessage, 'danger', element);
        }).always(function () {
            ajaxLocked = false;
        });
    }

    function refreshOrderListItems() {
        //Find out which form is active -> So that we can refresh the right list
        let ajaxSentFromProductOrderForm = false;
        if ($('div#product_order_form_wrapper').length) {
            ajaxSentFromProductOrderForm = true;
        }

        $.ajax({
            type: 'GET',
            url: ajaxPathRefreshOrderListItems,
            data: {
                ajax_sent_from_product_order_form: ajaxSentFromProductOrderForm
            },
            dataType: 'json'
        }).success(function (data) {
            if (ajaxSentFromProductOrderForm === false) {
                let productOrderListItemWrapper = $('div#goods_receipt_wrapper div#item_list_wrapper');
                let backOrderListItemWrapper = $('div#goods_receipt_wrapper div#back_order_item_list_wrapper');

                if (productOrderListItemWrapper.length) {
                    productOrderListItemWrapper.replaceWith(data.html_product_orders);
                }
                if (backOrderListItemWrapper.length) {
                    backOrderListItemWrapper.replaceWith(data.html_back_orders);
                }
            } else {
                let productOrderListWrapper = $('div#product_order_form_wrapper div#product_order_list_wrapper');

                if (productOrderListWrapper.length) {
                    productOrderListWrapper.replaceWith(data.html_product_orders);
                }
            }

        }).error(function (data) {
            modalTitle = 'Det oppstod en feil!';
            modalMessage = $.parseJSON(data.responseText).errors;
            modalAlertType = 'error';

            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
        });
    }

    function updateProductsTable(obj) {
        let urlString = '?';
        if (obj instanceof Object && 'product_order_id' in obj) {
            urlString += 'product_order_id=' + obj.product_order_id;
        }
        else if (obj instanceof Object && 'back_order_id' in obj) {
            urlString += 'back_order_id=' + obj.back_order_id;
        } else {
            let productGroupId = $('div#goods_receipt_wrapper select[name="product_group_filter"]').children("option:selected").val();
            let supplierId = $('div#goods_receipt_wrapper select[name="supplier_filter"]').children("option:selected").val();
            let searchString = $('div#goods_receipt_wrapper input#products_search_input').val();
            urlString += 'page=' + $('div#goods_receipt_wrapper div#pagination_wrapper li.active a').attr('data-pagenumber');
            if (productGroupId != -1) {
                urlString += '&product_group_id=' + productGroupId;
            }
            if (supplierId != -1) {
                urlString += '&supplier_id=' + supplierId;
            }
            if (searchString != '') {
                urlString += '&search_string=' + searchString;
            }
        }
        console.log('urlString: ' +urlString);

        $.ajax({
            type: 'GET',
            url: ajaxPathUpdateProductsTable + urlString,
            dataType: 'json'
        }).success(function (data) {
            $('div#goods_receipt_wrapper div#products_table_wrapper').replaceWith(data.html);
        }).error(function (data) {
            modalTitle = 'Det oppstod en feil!';
            modalMessage = $.parseJSON(data.responseText).errors;
            modalAlertType = 'error';

            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
        });
    }

    function updateURLParameter(url, param, paramVal) {
        let newAdditionalURL = "";
        let tempArray = url.split("?");
        let baseURL = tempArray[0];
        let additionalURL = tempArray[1];
        let temp = "";
        if (additionalURL) {
            tempArray = additionalURL.split("&");
            for (let i = 0; i < tempArray.length; i++) {
                if (tempArray[i].split('=')[0] != param) {
                    newAdditionalURL += temp + tempArray[i];
                    temp = "&";
                }
            }
        }

        let rows_txt = temp + "" + param + "=" + paramVal;
        return baseURL + "?" + newAdditionalURL + rows_txt;
    }
});